import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.video',
        video: '.video-js',
        videoCustomControls: '.video__controls',
        playPauseBtn: '.video__play-pause',
        seekslider: '.video__seekslider',
        currentTime: '.video__currentTime',
        durationTime: '.video__durationTime',
        volume: '.video__volume',
        fullscreen: '.video__fullscreen',
        captions: '.video__captions',
        thumbnail: '.video__thumbnail',
        thumbnailTimer: '.video__thumbnail-timer',

        volumeMute: '.video__volume--mute',
        volume25: '.video__volume--25',
        volume50: '.video__volume--50',
        volume75: '.video__volume--75',
        volume100: '.video__volume--100',
    },
    classNames: {
        fullscreen: 'video--fullscreen',
        overlay: 'gallery__main-slide-visual',
    },
    playIcon: '<span class="video__play-pause-icon icon-TickCirclePlay3"></span><span class="tooltip">Play</span>',
    pauseIcon: '<span class="video__play-pause-icon icon-TickCirclePause3"></span><span class="tooltip">Pause</span>'
};

class Video {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;

        this._playPauseHandler = this._playPauseHandler.bind(this);
        //this._captionsHandler = this._captionsHandler.bind(this);
        this._seeksliderThumbnailOnHover = this._seeksliderTimerOnHover.bind(this);
    }

    init() {
            this._elements = this._getDomElements();
            this._playPauseHandler();
            this._seeksliderChangeHandler();
            // this._seeksliderTimeUpdate();
            this._setVolume();
            this._setFullscreen();
            this._screenClick();
            this._createMenuItems();
            this._seeksliderTimerOnHover();
            // Funkction for video thumbnail base set-up
            // this._renderThumbnail();
        
    }

    _getDomElements() {
        return {
            $video: this._$rootElement.find(config.selectors.video),
            $videoCustomControls: this._$rootElement.find(config.selectors.videoCustomControls),
            $playPauseBtn: this._$rootElement.find(config.selectors.playPauseBtn),
            $seekslider: this._$rootElement.find(config.selectors.seekslider),
            $currentTime: this._$rootElement.find(config.selectors.currentTime),
            $durationTime: this._$rootElement.find(config.selectors.durationTime),
            $fullscreen: this._$rootElement.find(config.selectors.fullscreen),
            $captions: this._$rootElement.find(config.selectors.captions),
            $volume: this._$rootElement.find(config.selectors.volume),
            $volumeMute: this._$rootElement.find(config.selectors.volumeMute),
            $volume25: this._$rootElement.find(config.selectors.volume25),
            $volume50: this._$rootElement.find(config.selectors.volume50),
            $volume75: this._$rootElement.find(config.selectors.volume75),
            $volume100: this._$rootElement.find(config.selectors.volume100),
            $thumbnail: this._$rootElement.find(config.selectors.thumbnail),
            $thumbnailTimer: this._$rootElement.find(config.selectors.thumbnailTimer),
        };
    }

    _playPauseHandler() {
        const videoSettings = this._elements.$video[0];

        if(videoSettings && videoSettings.player) {
            this._seeksliderTimeUpdate(videoSettings);

            videoSettings.player.on('play', () => {
                this._elements.$playPauseBtn.html(config.pauseIcon);
            });
        }

        this._elements.$playPauseBtn.on('click', (e) => {
            if (videoSettings.player.paused()) {
                this._seeksliderTimeUpdate(videoSettings);
                videoSettings.player.play();
                this._elements.$playPauseBtn.html(config.pauseIcon);
            } else {
                videoSettings.player.pause();
                this._elements.$playPauseBtn.html(config.playIcon);
            }
        });

        
    }

    _seeksliderChangeHandler() {

        this._elements.$seekslider.on('change', () => {
            const videoSettings = this._elements.$video[0];

            const seekTo = videoSettings.player.duration() * (this._elements.$seekslider[0].value / 100);
            videoSettings.player.currentTime(seekTo);
        })
    }

    _seeksliderTimerOnHover() {
        const videoSettings = this._elements.$video[0];
        const progressBar = this._elements.$seekslider;
        const thumbnail = this._elements.$thumbnail;
        let mouseHoverTime = 0;
        thumbnail.hide();

        progressBar.on('mouseover', () => {
            thumbnail.show();
        })

        progressBar.on('mouseleave', () => {
            thumbnail.hide();
        })

        progressBar.mousemove((e) => {
            const mousePositionX = e.pageX;
            const progressBarPosition = progressBar[0].getBoundingClientRect();
            const mouseTime = (mousePositionX - progressBarPosition.x) / progressBarPosition.width * videoSettings.duration;
            mouseHoverTime = Math.floor((mouseTime * 100) / 100) / 100;
            if (parseFloat(mouseHoverTime).toFixed(2) < 0.00) {
                thumbnail.hide();
                return;
            }
            this._elements.$thumbnailTimer.html(parseFloat(mouseHoverTime).toFixed(2));
            thumbnail.css({'top':progressBarPosition.y,'left':(mousePositionX - progressBarPosition.x), 'position':'absolute', 'border':'1px solid black', 'padding':'5px', 'border-radius': '5px'});
            // this._renderThumbnail();
        });
    }

    // Gets canvas elements and renders a piece of the running video in thunmbnail element
    /*_renderThumbnail() {
        const video = document.querySelector(config.selectors.video);
        const processor = {};

        const timerCallback = () => {
            if (this.video.paused || this.video.ended) {
              return;
            }
            computeFrame();
            setTimeout(() => {
                timerCallback();
              }, 0);
          };

        video.addEventListener('loadeddata', () => {
            console.log('doLoad');
            this.video = video;

            this.c1 = document.getElementById('c1');
            this.ctx1 = this.c1.getContext('2d');

            this.c2 = document.getElementById('c2');
            this.ctx2 = this.c2.getContext('2d');

            console.log('canvas - c1: ', this.c1);
            console.log('canvas - ctx1: ', this.ctx1);

            console.log('canvas - c2: ', this.c2);
            console.log('canvas - ctx2: ', this.ctx2);

            video.addEventListener('play', () => {
                this.width = video.videoWidth / 2;
                this.height = video.videoHeight / 2;
                timerCallback();
                }, false);
        });

          const computeFrame = () => {
            console.log('computeFrame');
            this.ctx1.drawImage(this.video, 0, 0, this.width, this.height);
            const frame = this.ctx1.getImageData(0, 0, this.width, this.height);
            const length = frame.data.length;
            const data = frame.data;

            for (let i = 0; i < length; i += 4) {
              const red = data[i + 0];
              const green = data[i + 1];
              const blue = data[i + 2];
              if (green > 100 && red > 100 && blue < 43) {
                data[i + 3] = 0;
              }
            }
            this.ctx2.putImageData(frame, 0, 0);
          };
    }*/

    _seeksliderTimeUpdate(videoSettings) {
        videoSettings.player.on('timeupdate', () => {
            if (videoSettings.player.ended()) {
                videoSettings.player.pause();
                return;
            };
            const newTime = videoSettings.player.currentTime() * (100 / videoSettings.player.duration());
            this._elements.$seekslider[0].value = newTime;
            let curmins = Math.floor(videoSettings.player.currentTime() / 60);
            let cursecs = Math.floor(videoSettings.player.currentTime() - curmins * 60);
            let durmins = Math.floor(videoSettings.player.duration() / 60);
            let dursecs = Math.floor(videoSettings.player.duration() - durmins * 60);
            if(cursecs < 10){ cursecs = "0"+cursecs; }
            if(dursecs < 10){ dursecs = "0"+dursecs; }
            if(curmins < 10){ curmins = "0"+curmins; }
            if(durmins < 10){ durmins = "0"+durmins; }
            this._elements.$currentTime.html(curmins+":"+cursecs);
            this._elements.$durationTime.html(durmins+":"+dursecs);
        })
    }

    _setVolume() {
        const videoSettings = this._elements.$video[0];
       
        this._elements.$volume.on('click', (e) => {
           
            const volumeValue = e.currentTarget.value / 100;
      
            if (volumeValue === 0) {
                videoSettings.player.volume(.25);
                this._elements.$volumeMute.hide();
                this._elements.$volume25.show();
            } else if (volumeValue === .25) {
                videoSettings.player.volume(.5);
                this._elements.$volume25.hide();
                this._elements.$volume50.show();
            } else if (volumeValue === .50) {
                videoSettings.player.volume(.75);
                this._elements.$volume50.hide();
                this._elements.$volume75.show();
            } else if (volumeValue === .75) {
                videoSettings.player.volume(1);
                this._elements.$volume75.hide();
                this._elements.$volume100.show();
            } else if (volumeValue === 1) {
                videoSettings.player.volume(0);
                this._elements.$volume100.hide();
                this._elements.$volumeMute.show();
            }
        })
    }

    _setFullscreen() {
        const videoSettings = this._elements.$video[0];
        this._elements.$fullscreen.on('click', () => {
          
            if (!this._$rootElement.parent().hasClass(config.classNames.overlay)) {
                if (this._$rootElement.hasClass(config.classNames.fullscreen)) {
                    this._$rootElement.removeClass(config.classNames.fullscreen);
                    this._$rootElement.find('.video__fullscreen-icon').removeClass('icon-arrowShrink').addClass('icon-StateDark13');
                } else {
                    this._$rootElement.addClass(config.classNames.fullscreen)
                    this._$rootElement.find('.video__fullscreen-icon').removeClass('icon-StateDark13').addClass('icon-arrowShrink');
                    // this._elements.$backdrop.addClass('');
                }
            }


        });
    }

    _screenClick() {
        const videoSettings = this._elements.$video[0];
        this._elements.$video.on('click', (e) => {
            const videoPaused = this._elements.$video.hasClass('vjs-paused');

            if (videoPaused) {
                videoSettings.player.play();
                this._seeksliderTimeUpdate(videoSettings);
                this._elements.$playPauseBtn.html(config.pauseIcon);
            } else {
                videoSettings.player.pause();
                this._elements.$playPauseBtn.html(config.playIcon);
            }
        })
    }



    _createMenuItems(id, lang, label) {
        const videoSettings = this._elements.$video[0];
        const captionsMenuButtons = [];
        const listItem = document.createElement('li');
        const button = listItem.appendChild(document.createElement('button'));
        button.setAttribute('id', id);
        button.classList.add('video__captions-button');
        if (lang?.length > 0) button.setAttribute('lang', lang);
        button.value = label;
        button.setAttribute('data-state', 'inactive');
        button.appendChild(document.createTextNode(label));

        $(button).on('click', (v, i, a) => {
            captionsMenuButtons.map(() => {
                captionsMenuButtons[i].setAttribute('data-state', 'inactive');
            });
            const lang = this.getAttribute('lang');
            for (let i = 0; i < videoSettings.textTracks.length; i++) {
                if (videoSettings.textTracks[i].language == lang) {
                    videoSettings.textTracks[i].mode = 'showing';
                    this.setAttribute('data-sate', 'active');
                } else {
                    videoSettings.textTracks[i].mode = 'hidden';
                }
            }
            $('video__captions-menu')[0].style.display = 'none';
        });
        captionsMenuButtons.push(button);
        return listItem;

    }
}

moduleRegistry.registerModule('Video', Video);
moduleRegistry.autoApplyModule('Video', config.selectors.root);